import { Component, OnInit } from '@angular/core';
import { Moderation } from 'src/app/classes/moderation';
import { ModerationService } from 'src/app/services/moderation.service';

@Component({
  selector: 'app-retour',
  templateUrl: './retour.component.html',
  styleUrls: ['./retour.component.css']
})
export class RetourComponent implements OnInit {
  moderations: Moderation[];
  constructor(private moderationService: ModerationService) { }

  ngOnInit(): void {
  }

  panelStyle(): object {
    return {
      'min-height': '1000px;'
    };
  }
}
